// extracted by mini-css-extract-plugin
module.exports = {"base":"nineStories-m__base__26zoU"};